const useSubAdmin = () => {
  const drawerMenu = [];

  return {
    drawerMenu,
  };
};

export default useSubAdmin;
